import {
  SmartwaysLocationLinkRequest,
  SmartwaysLocationLinkResponse,
  SmartwaysLocationsResponse,
} from 'api/models/Smartways';
import ApiClientBase from './ApiClientBase';

class SmartwaysEndpoint extends ApiClientBase {
  apiUri = '/api/v2/smartways';

  linkLocation(request: SmartwaysLocationLinkRequest) {
    return this.apiCall<SmartwaysLocationLinkResponse>(`/locations/link/`, 'post', request);
  }

  listLocations() {
    return this.apiCall<SmartwaysLocationsResponse>(`/locations/`, 'get');
  }

  unlinkLocation(swLocationId: number) {
    return this.apiCall<void>(`/locations/link/${swLocationId}/`, 'delete');
  }
}

const smartways = new SmartwaysEndpoint();

export default smartways;
